import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

// Add custom animation keyframes for indeterminate progress
const indeterminateKeyframes = `
@keyframes indeterminate {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(400%);
  }
}
`

function Progress({
  className,
  value,
  indeterminate = false,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & {
  indeterminate?: boolean
}) {
  return (
    <>
      <style>{indeterminateKeyframes}</style>
      <ProgressPrimitive.Root
        data-slot="progress"
        className={cn(
          "bg-primary/20 relative h-2 w-full overflow-hidden rounded-full",
          className
        )}
        {...props}
      >
        <ProgressPrimitive.Indicator
          data-slot="progress-indicator"
          className={cn(
            "bg-primary h-full transform-gpu will-change-transform transition-transform duration-200 ease-linear",
            indeterminate
              ? "w-[30%] animate-[indeterminate_1.5s_ease-in-out_infinite]"
              : "w-full"
          )}
          style={
            indeterminate
              ? undefined
              : { transform: `translateX(-${100 - (value || 0)}%)` }
          }
        />
      </ProgressPrimitive.Root>
    </>
  )
}

export { Progress }
